import { getToken, handleResponse, nextJsonApi } from '@/API/core';

const store = {
  getRowData: async (company_id: string | undefined) => {
    const token = await getToken();
    let response = null;
    try {
      response = await nextJsonApi.get('/store?company_id=' + company_id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  addLocation: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post('/store', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  editLocation: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.put('/store', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  editTaxInfo: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.put('/tax-info', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default store;
